import React, { useContext } from "react"
import { serviceInnerContainer } from "./modal.module.css"
import ModalLayout from './ModalLayout'
import { ModalContext } from "src/context/ModalContext"

export const ProductInfo = () => {
  const { modalData } = useContext( ModalContext )

  return (
    <ModalLayout>
      <div className={ serviceInnerContainer }>
        <img src={ modalData.imgHiRes } alt={ modalData.alt || "Product image" } />
        <header align="left">
          <h1>{ modalData.name }</h1>
        </header>
        <p>{ modalData.description }</p>
      </div>
    </ModalLayout>
  )
}

export default ProductInfo
